/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { useTheme, StatusIconMap, SvgCloseSmall } from '../utils/index.js';
/**
 * A small box to quickly grab user attention and communicate a brief message
 * @example
 * <Alert>This is a basic alert.</Alert>
 * <Alert type='positive'>This is a positive alert.</Alert>
 * <Alert type='warning'>This is a warning alert.</Alert>
 * <Alert type='negative'>This is a negative alert.</Alert>
 * <Alert
 *  type='positive'
 *  clickableText="I am a clickable text"
 *  clickableTextProps={{ href: 'https://www.example.com' }}
 * >
 *   This is a positive alert with a clickable text
 * </Alert>
 */
export const Alert = (props) => {
    const { children, className, type = 'informational', clickableText, clickableTextProps, onClose, style, isSticky = false, ...rest } = props;
    useTheme();
    const StatusIcon = StatusIconMap[type];
    return (React.createElement("div", { className: cx('iui-alert', className), "data-iui-status": type, "data-iui-variant": isSticky ? 'sticky' : undefined, style: style, ...rest },
        React.createElement(StatusIcon, { className: 'iui-alert-icon' }),
        React.createElement("span", { className: 'iui-alert-message' },
            children,
            clickableText && (React.createElement("a", { ...clickableTextProps, className: cx('iui-alert-link', clickableTextProps === null || clickableTextProps === void 0 ? void 0 : clickableTextProps.className) }, clickableText))),
        onClose && (React.createElement("button", { onClick: onClose, "aria-label": 'Close', type: 'button', className: 'iui-alert-button' },
            React.createElement("span", { className: 'iui-alert-button-icon', "aria-hidden": true },
                React.createElement(SvgCloseSmall, null))))));
};
export default Alert;
